import { Box, Grid, Typography } from '@mui/material';
import { gridContainer, infoGridItem } from '../Styles/CustodianContactDetailsStyles';
import { labelText, labelTitle } from '../../../assets/styles/appStyles';

export default function EntityNotesDetails({
  notes,
}: {
  notes: string;
}) {
  return (
    <>
      <Grid rowSpacing={3} container sx={gridContainer}>
        <Grid xs={12} item container sx={infoGridItem}>
          <Grid item xs={12} sx={infoGridItem}>
            <Typography align="left" sx={labelTitle}>
              Notes
            </Typography>
            <Box>
              <Typography sx={labelText}>{notes ?? '-'}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
